import { render, staticRenderFns } from "./AddPromRule.vue?vue&type=template&id=72cfa2f2&scoped=true"
import script from "./AddPromRule.vue?vue&type=script&lang=js"
export * from "./AddPromRule.vue?vue&type=script&lang=js"
import style0 from "./AddPromRule.vue?vue&type=style&index=0&id=72cfa2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cfa2f2",
  null
  
)

export default component.exports